module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "booking-select"
  }, [_c('div', {
    staticClass: "close-wrapper",
    on: {
      "click": _vm.onClear
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-close close"
  })]), _vm._v(" "), _c('div', {
    staticClass: "click-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSelectClick($event)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-check check"
  }), _vm._v(" "), _c('div', {
    staticClass: "select-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [(!_vm.showOptions && !_vm.selected) ? _c('div', {
    staticClass: "placeholder"
  }, [_vm._v(" " + _vm._s(_vm.placeholder) + " ")]) : (!_vm.showOptions && _vm.selected) ? _c('div', {
    staticClass: "selected"
  }, [_vm._v(_vm._s(_vm.selected))]) : _c('div', {
    staticClass: "options"
  }, _vm._l((_vm.options), function(o) {
    return _c('div', {
      key: o.id,
      staticClass: "option",
      on: {
        "click": function($event) {
          _vm.onOptionClick(o)
        }
      }
    }, [_vm._v("\n          " + _vm._s(o.name) + "\n        ")])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-093f847e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booker/BookingSelect.vue
// module id = 856
// module chunks = 2